<template>
  <div class="result-table">
    <div class="exhibitionCatalog">
      <h2
        class="catalog-title"
        :title="$t('pages.results.catalogTitle')"
        role="link"
        @click="openCatalogDialog"
      >
        {{section.exhibition_catalog_title}}, <span title="Ville">{{section.city}}</span>
        <span v-if="section.publishing_year">, {{section.publishing_year}}</span>
        <el-button
          @click="exportCatalog"
          size="small"
          v-loading="exporting"
        >
          {{$t('pages.results.exportCsv')}}
        </el-button>
      </h2>

      <h3
        class="title"
        v-if="section.exhibition_section_title"
      >
        {{$t('pages.results.section')}}
        {{section.exhibition_section_title}}
      </h3>

      <span v-if="section.space">{{section.space}}</span><span v-if="section.address && section.space">, </span>
      <span v-if="section.address">{{section.address}}</span><span v-if="section.address && section.city">, </span>
      <span v-if="section.city">{{section.city}}</span><br>

      <CatalogDates :catalog="section" />
      <div v-if="section.source_catalog">
        {{$t('pages.results.source_catalog_lower')}} : <cite>{{section.source_catalog}}</cite>
      </div>
      <cite v-if="section.contributor">
        {{$t('pages.results.filledBy')}}
        <span>{{ section.contributor }}.</span>
      </cite>

    </div>
    <el-table
      :data="section.exhibitors.results"
      stripe
      border
      v-loading="section.exhibitors.loading"
      @expand="fetchExhibitedWork">
      <el-table-column type="expand">
        <template slot-scope="props">
          <div v-if="props.row.biography">
            <h4>{{$t('pages.results.biography')}}</h4>
            {{props.row.biography}}
          </div>

          <div v-if="props.row.notes">
            <h4>{{$t('pages.results.notes')}}</h4>
            {{props.row.notes}}
          </div>

          <div v-if="props.row.exhibitedWork">
            <h4>{{$t('pages.results.exhibitedWorks')}}</h4>
            <div
              v-loading="props.row.exhibitedWork.loading"
              v-for="result in props.row.exhibitedWork.results"
              :key="result.id"
            >
              <ExhibitedWorkDialog :exhibitedWork="result"></ExhibitedWorkDialog>
            </div>
            <span v-if="props.row.exhibitedWork.results.length === 0">
              {{$t('pages.results.unknown')}}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        width="150"
        :label="$t('pages.results.name_firstname')"
	>
        <template slot-scope="props">
          {{props.row.name}}
          <span v-if="!props.row.name" class="missing-name">{{$t('pages.results.nameMissing')}}</span>
          <span v-if="props.row.first_name">, {{props.row.first_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gender"
        width="90"
        :label="$t('pages.results.gender')" />
      <el-table-column
        prop="address"
        :label="$t('pages.results.address')" />
      <el-table-column
        prop="nationality"
        :label="$t('pages.results.nationality')" />
      <el-table-column
        prop="year_b"
        :label="$t('pages.results.birth')" />
      <el-table-column
        prop="year_d"
        :label="$t('pages.results.death')" />
      <el-table-column
        prop="instructor"
        :label="$t('pages.results.instructor')" />
    </el-table>
  </div>
</template>

<script>
import {
  Dialog,
  Table, TableColumn, Button
} from 'element-ui'
import {
  OPEN_CATALOG_DIALOG,
  GET_CATALOG
} from '@/store/dialog/actions'
import ExhibitedWorkDialog from '../../ExhibitedWork/ExhibitedWorkDialog.vue'
import { GET_EXHIBITED_WORK } from '../../../store/dialog/actions'
import { EXHIBITED_WORK } from '@/services/filters'
import { exportCSV } from '@/services/export'

import CatalogDates from '../../Catalog/CatalogDates'
export default {
  name: 'tableExhibitorDetail',
  props: ['section'],
  components: {
    elTable: Table,
    elTableColumn: TableColumn,
    elButton: Button,
    elDialog: Dialog,
    ExhibitedWorkDialog,
    CatalogDates
  },
  data: function () {
    return {
      exporting: false
    }
  },
  methods: {
    fetchExhibitedWork (row, expanded) {
      if (expanded === true) {
        // dispatch action to load exhibited work for row.id exhibitor
        this.$set(row, 'exhibitedWork', {})
        this.$store.dispatch('dialog/' + GET_EXHIBITED_WORK, {
          sectionId: row.id_exhibition_section,
          exhibitorId: row.id,
          objectToIncrement: row.exhibitedWork
        })
      }
    },
    openCatalogDialog () {
      this.$store.dispatch('dialog/' + OPEN_CATALOG_DIALOG)
      this.$store.dispatch('dialog/' + GET_CATALOG, {
        id: this.section.id_exhibition
      })
    },
    getSectionTitle () {
      const title = this.section.exhibition_section_title

      if (title !== null) {
        return 'Section : ' + title
      }
      return 'Section'
    },
    async exportCatalog () {
      this.exporting = true
      await exportCSV(EXHIBITED_WORK, {
        filters: `[
          {
            "property":"id_catalog",
            "matchType":"eq",
            "value":"${this.section.id_exhibition_catalog}"
          }
        ]`
      })
      this.exporting = false
    }
  }
}
</script>
<style>
.catalog-title {
  color: #23a6b9;
}
.catalog-title:hover,
.catalog-title:active {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/Tables/TableExhibitorDetail.vue